export default [
  [
    "阿",
    "阿"
  ],
  [
    "哎",
    "哎"
  ],
  [
    "艾",
    "艾"
  ],
  [
    "愛",
    "愛"
  ],
  [
    "安",
    "安"
  ],
  [
    "獒",
    "獒"
  ],
  [
    "傲",
    "傲"
  ],
  [
    "奧",
    "奧"
  ],
  [
    "八",
    "八"
  ],
  [
    "巴",
    "巴"
  ],
  [
    "扒",
    "扒"
  ],
  [
    "芭",
    "芭"
  ],
  [
    "霸",
    "霸"
  ],
  [
    "白",
    "白"
  ],
  [
    "百",
    "百"
  ],
  [
    "敗",
    "敗"
  ],
  [
    "班",
    "班"
  ],
  [
    "斑",
    "斑"
  ],
  [
    "搬",
    "搬"
  ],
  [
    "保",
    "保"
  ],
  [
    "寶",
    "寶"
  ],
  [
    "暴",
    "暴"
  ],
  [
    "爆",
    "爆"
  ],
  [
    "比",
    "比"
  ],
  [
    "畢",
    "畢"
  ],
  [
    "變",
    "變"
  ],
  [
    "冰",
    "冰"
  ],
  [
    "波",
    "波"
  ],
  [
    "不",
    "不"
  ],
  [
    "布",
    "布"
  ],
  [
    "步",
    "步"
  ],
  [
    "怖",
    "怖"
  ],
  [
    "彩",
    "彩"
  ],
  [
    "蒼",
    "蒼"
  ],
  [
    "藏",
    "藏"
  ],
  [
    "操",
    "操"
  ],
  [
    "草",
    "草"
  ],
  [
    "叉",
    "叉"
  ],
  [
    "差",
    "差"
  ],
  [
    "蟾",
    "蟾"
  ],
  [
    "纏",
    "纏"
  ],
  [
    "顫",
    "顫"
  ],
  [
    "超",
    "超"
  ],
  [
    "朝",
    "朝"
  ],
  [
    "炒",
    "炒"
  ],
  [
    "車",
    "車"
  ],
  [
    "吃",
    "吃"
  ],
  [
    "齒",
    "齒"
  ],
  [
    "赤",
    "赤"
  ],
  [
    "熾",
    "熾"
  ],
  [
    "蟲",
    "蟲"
  ],
  [
    "銃",
    "銃"
  ],
  [
    "醜",
    "醜"
  ],
  [
    "臭",
    "臭"
  ],
  [
    "觸",
    "觸"
  ],
  [
    "穿",
    "穿"
  ],
  [
    "刺",
    "刺"
  ],
  [
    "蔥",
    "蔥"
  ],
  [
    "催",
    "催"
  ],
  [
    "達",
    "達"
  ],
  [
    "打",
    "打"
  ],
  [
    "大",
    "大"
  ],
  [
    "呆",
    "呆"
  ],
  [
    "代",
    "代"
  ],
  [
    "袋",
    "袋"
  ],
  [
    "戴",
    "戴"
  ],
  [
    "單",
    "單"
  ],
  [
    "膽",
    "膽"
  ],
  [
    "蛋",
    "蛋"
  ],
  [
    "搗",
    "搗"
  ],
  [
    "地",
    "地"
  ],
  [
    "燈",
    "燈"
  ],
  [
    "滴",
    "滴"
  ],
  [
    "帝",
    "帝"
  ],
  [
    "蒂",
    "蒂"
  ],
  [
    "電",
    "電"
  ],
  [
    "蝶",
    "蝶"
  ],
  [
    "咚",
    "咚"
  ],
  [
    "東",
    "東"
  ],
  [
    "凍",
    "凍"
  ],
  [
    "斗",
    "斗"
  ],
  [
    "豆",
    "豆"
  ],
  [
    "嘟",
    "嘟"
  ],
  [
    "毒",
    "毒"
  ],
  [
    "獨",
    "獨"
  ],
  [
    "堵",
    "堵"
  ],
  [
    "盾",
    "盾"
  ],
  [
    "頓",
    "頓"
  ],
  [
    "多",
    "多"
  ],
  [
    "惡",
    "惡"
  ],
  [
    "飯",
    "飯"
  ],
  [
    "芳",
    "芳"
  ],
  [
    "彷",
    "彷"
  ],
  [
    "飛",
    "飛"
  ],
  [
    "霏",
    "霏"
  ],
  [
    "費",
    "費"
  ],
  [
    "焚",
    "焚"
  ],
  [
    "粉",
    "粉"
  ],
  [
    "風",
    "風"
  ],
  [
    "蜂",
    "蜂"
  ],
  [
    "豐",
    "豐"
  ],
  [
    "鳳",
    "鳳"
  ],
  [
    "佛",
    "佛"
  ],
  [
    "浮",
    "浮"
  ],
  [
    "斧",
    "斧"
  ],
  [
    "負",
    "負"
  ],
  [
    "嘎",
    "嘎"
  ],
  [
    "蓋",
    "蓋"
  ],
  [
    "鋼",
    "鋼"
  ],
  [
    "高",
    "高"
  ],
  [
    "哥",
    "哥"
  ],
  [
    "耿",
    "耿"
  ],
  [
    "功",
    "功"
  ],
  [
    "勾",
    "勾"
  ],
  [
    "狗",
    "狗"
  ],
  [
    "呱",
    "呱"
  ],
  [
    "咕",
    "咕"
  ],
  [
    "古",
    "古"
  ],
  [
    "骨",
    "骨"
  ],
  [
    "固",
    "固"
  ],
  [
    "故",
    "故"
  ],
  [
    "聒",
    "聒"
  ],
  [
    "怪",
    "怪"
  ],
  [
    "光",
    "光"
  ],
  [
    "龜",
    "龜"
  ],
  [
    "鬼",
    "鬼"
  ],
  [
    "詭",
    "詭"
  ],
  [
    "滾",
    "滾"
  ],
  [
    "果",
    "果"
  ],
  [
    "過",
    "過"
  ],
  [
    "哈",
    "哈"
  ],
  [
    "海",
    "海"
  ],
  [
    "含",
    "含"
  ],
  [
    "豪",
    "豪"
  ],
  [
    "好",
    "好"
  ],
  [
    "浩",
    "浩"
  ],
  [
    "河",
    "河"
  ],
  [
    "赫",
    "赫"
  ],
  [
    "黑",
    "黑"
  ],
  [
    "狠",
    "狠"
  ],
  [
    "轟",
    "轟"
  ],
  [
    "紅",
    "紅"
  ],
  [
    "猴",
    "猴"
  ],
  [
    "吼",
    "吼"
  ],
  [
    "狐",
    "狐"
  ],
  [
    "胡",
    "胡"
  ],
  [
    "壺",
    "壺"
  ],
  [
    "戽",
    "戽"
  ],
  [
    "護",
    "護"
  ],
  [
    "花",
    "花"
  ],
  [
    "滑",
    "滑"
  ],
  [
    "化",
    "化"
  ],
  [
    "晃",
    "晃"
  ],
  [
    "灰",
    "灰"
  ],
  [
    "混",
    "混"
  ],
  [
    "火",
    "火"
  ],
  [
    "基",
    "基"
  ],
  [
    "吉",
    "吉"
  ],
  [
    "急",
    "急"
  ],
  [
    "幾",
    "幾"
  ],
  [
    "戟",
    "戟"
  ],
  [
    "甲",
    "甲"
  ],
  [
    "尖",
    "尖"
  ],
  [
    "堅",
    "堅"
  ],
  [
    "毽",
    "毽"
  ],
  [
    "角",
    "角"
  ],
  [
    "狡",
    "狡"
  ],
  [
    "捷",
    "捷"
  ],
  [
    "傑",
    "傑"
  ],
  [
    "結",
    "結"
  ],
  [
    "金",
    "金"
  ],
  [
    "晶",
    "晶"
  ],
  [
    "驚",
    "驚"
  ],
  [
    "九",
    "九"
  ],
  [
    "狙",
    "狙"
  ],
  [
    "駒",
    "駒"
  ],
  [
    "菊",
    "菊"
  ],
  [
    "巨",
    "巨"
  ],
  [
    "具",
    "具"
  ],
  [
    "捲",
    "捲"
  ],
  [
    "眷",
    "眷"
  ],
  [
    "掘",
    "掘"
  ],
  [
    "君",
    "君"
  ],
  [
    "卡",
    "卡"
  ],
  [
    "凱",
    "凱"
  ],
  [
    "科",
    "科"
  ],
  [
    "可",
    "可"
  ],
  [
    "克",
    "克"
  ],
  [
    "肯",
    "肯"
  ],
  [
    "啃",
    "啃"
  ],
  [
    "口",
    "口"
  ],
  [
    "哭",
    "哭"
  ],
  [
    "酷",
    "酷"
  ],
  [
    "快",
    "快"
  ],
  [
    "狂",
    "狂"
  ],
  [
    "盔",
    "盔"
  ],
  [
    "垃",
    "垃"
  ],
  [
    "拉",
    "拉"
  ],
  [
    "喇",
    "喇"
  ],
  [
    "來",
    "來"
  ],
  [
    "萊",
    "萊"
  ],
  [
    "藍",
    "藍"
  ],
  [
    "蘭",
    "蘭"
  ],
  [
    "懶",
    "懶"
  ],
  [
    "老",
    "老"
  ],
  [
    "肋",
    "肋"
  ],
  [
    "樂",
    "樂"
  ],
  [
    "勒",
    "勒"
  ],
  [
    "雷",
    "雷"
  ],
  [
    "蕾",
    "蕾"
  ],
  [
    "壘",
    "壘"
  ],
  [
    "淚",
    "淚"
  ],
  [
    "冷",
    "冷"
  ],
  [
    "鯉",
    "鯉"
  ],
  [
    "力",
    "力"
  ],
  [
    "利",
    "利"
  ],
  [
    "蓮",
    "蓮"
  ],
  [
    "鐮",
    "鐮"
  ],
  [
    "涼",
    "涼"
  ],
  [
    "列",
    "列"
  ],
  [
    "烈",
    "烈"
  ],
  [
    "獵",
    "獵"
  ],
  [
    "鱗",
    "鱗"
  ],
  [
    "鈴",
    "鈴"
  ],
  [
    "靈",
    "靈"
  ],
  [
    "溜",
    "溜"
  ],
  [
    "流",
    "流"
  ],
  [
    "六",
    "六"
  ],
  [
    "隆",
    "隆"
  ],
  [
    "龍",
    "龍"
  ],
  [
    "陸",
    "陸"
  ],
  [
    "路",
    "路"
  ],
  [
    "露",
    "露"
  ],
  [
    "鋁",
    "鋁"
  ],
  [
    "綠",
    "綠"
  ],
  [
    "倫",
    "倫"
  ],
  [
    "螺",
    "螺"
  ],
  [
    "羅",
    "羅"
  ],
  [
    "洛",
    "洛"
  ],
  [
    "落",
    "落"
  ],
  [
    "麻",
    "麻"
  ],
  [
    "瑪",
    "瑪"
  ],
  [
    "蔓",
    "蔓"
  ],
  [
    "貓",
    "貓"
  ],
  [
    "毛",
    "毛"
  ],
  [
    "煤",
    "煤"
  ],
  [
    "美",
    "美"
  ],
  [
    "魅",
    "魅"
  ],
  [
    "萌",
    "萌"
  ],
  [
    "猛",
    "猛"
  ],
  [
    "夢",
    "夢"
  ],
  [
    "迷",
    "迷"
  ],
  [
    "謎",
    "謎"
  ],
  [
    "米",
    "米"
  ],
  [
    "密",
    "密"
  ],
  [
    "綿",
    "綿"
  ],
  [
    "喵",
    "喵"
  ],
  [
    "妙",
    "妙"
  ],
  [
    "咩",
    "咩"
  ],
  [
    "敏",
    "敏"
  ],
  [
    "摩",
    "摩"
  ],
  [
    "磨",
    "磨"
  ],
  [
    "蘑",
    "蘑"
  ],
  [
    "魔",
    "魔"
  ],
  [
    "莫",
    "莫"
  ],
  [
    "墨",
    "墨"
  ],
  [
    "姆",
    "姆"
  ],
  [
    "木",
    "木"
  ],
  [
    "墓",
    "墓"
  ],
  [
    "幕",
    "幕"
  ],
  [
    "納",
    "納"
  ],
  [
    "奈",
    "奈"
  ],
  [
    "南",
    "南"
  ],
  [
    "尼",
    "尼"
  ],
  [
    "泥",
    "泥"
  ],
  [
    "霓",
    "霓"
  ],
  [
    "黏",
    "黏"
  ],
  [
    "鯰",
    "鯰"
  ],
  [
    "念",
    "念"
  ],
  [
    "狃",
    "狃"
  ],
  [
    "怒",
    "怒"
  ],
  [
    "暖",
    "暖"
  ],
  [
    "偶",
    "偶"
  ],
  [
    "啪",
    "啪"
  ],
  [
    "爬",
    "爬"
  ],
  [
    "帕",
    "帕"
  ],
  [
    "派",
    "派"
  ],
  [
    "龐",
    "龐"
  ],
  [
    "胖",
    "胖"
  ],
  [
    "泡",
    "泡"
  ],
  [
    "噴",
    "噴"
  ],
  [
    "盆",
    "盆"
  ],
  [
    "砰",
    "砰"
  ],
  [
    "劈",
    "劈"
  ],
  [
    "霹",
    "霹"
  ],
  [
    "皮",
    "皮"
  ],
  [
    "飄",
    "飄"
  ],
  [
    "蘋",
    "蘋"
  ],
  [
    "破",
    "破"
  ],
  [
    "仆",
    "仆"
  ],
  [
    "噗",
    "噗"
  ],
  [
    "普",
    "普"
  ],
  [
    "七",
    "七"
  ],
  [
    "奇",
    "奇"
  ],
  [
    "騎",
    "騎"
  ],
  [
    "麒",
    "麒"
  ],
  [
    "棄",
    "棄"
  ],
  [
    "恰",
    "恰"
  ],
  [
    "千",
    "千"
  ],
  [
    "鉗",
    "鉗"
  ],
  [
    "強",
    "強"
  ],
  [
    "敲",
    "敲"
  ],
  [
    "鍬",
    "鍬"
  ],
  [
    "巧",
    "巧"
  ],
  [
    "青",
    "青"
  ],
  [
    "蜻",
    "蜻"
  ],
  [
    "輕",
    "輕"
  ],
  [
    "請",
    "請"
  ],
  [
    "酋",
    "酋"
  ],
  [
    "球",
    "球"
  ],
  [
    "圈",
    "圈"
  ],
  [
    "拳",
    "拳"
  ],
  [
    "裙",
    "裙"
  ],
  [
    "燃",
    "燃"
  ],
  [
    "熱",
    "熱"
  ],
  [
    "人",
    "人"
  ],
  [
    "茸",
    "茸"
  ],
  [
    "溶",
    "溶"
  ],
  [
    "熔",
    "熔"
  ],
  [
    "潤",
    "潤"
  ],
  [
    "弱",
    "弱"
  ],
  [
    "薩",
    "薩"
  ],
  [
    "鰓",
    "鰓"
  ],
  [
    "賽",
    "賽"
  ],
  [
    "三",
    "三"
  ],
  [
    "傘",
    "傘"
  ],
  [
    "森",
    "森"
  ],
  [
    "沙",
    "沙"
  ],
  [
    "閃",
    "閃"
  ],
  [
    "燒",
    "燒"
  ],
  [
    "蛇",
    "蛇"
  ],
  [
    "紳",
    "紳"
  ],
  [
    "師",
    "師"
  ],
  [
    "石",
    "石"
  ],
  [
    "食",
    "食"
  ],
  [
    "時",
    "時"
  ],
  [
    "始",
    "始"
  ],
  [
    "噬",
    "噬"
  ],
  [
    "狩",
    "狩"
  ],
  [
    "屬",
    "屬"
  ],
  [
    "樹",
    "樹"
  ],
  [
    "摔",
    "摔"
  ],
  [
    "霜",
    "霜"
  ],
  [
    "雙",
    "雙"
  ],
  [
    "水",
    "水"
  ],
  [
    "睡",
    "睡"
  ],
  [
    "死",
    "死"
  ],
  [
    "四",
    "四"
  ],
  [
    "隨",
    "隨"
  ],
  [
    "索",
    "索"
  ],
  [
    "踏",
    "踏"
  ],
  [
    "太",
    "太"
  ],
  [
    "貪",
    "貪"
  ],
  [
    "坦",
    "坦"
  ],
  [
    "炭",
    "炭"
  ],
  [
    "探",
    "探"
  ],
  [
    "藤",
    "藤"
  ],
  [
    "騰",
    "騰"
  ],
  [
    "提",
    "提"
  ],
  [
    "天",
    "天"
  ],
  [
    "甜",
    "甜"
  ],
  [
    "跳",
    "跳"
  ],
  [
    "鐵",
    "鐵"
  ],
  [
    "童",
    "童"
  ],
  [
    "銅",
    "銅"
  ],
  [
    "偷",
    "偷"
  ],
  [
    "投",
    "投"
  ],
  [
    "頭",
    "頭"
  ],
  [
    "禿",
    "禿"
  ],
  [
    "塗",
    "塗"
  ],
  [
    "圖",
    "圖"
  ],
  [
    "土",
    "土"
  ],
  [
    "團",
    "團"
  ],
  [
    "吞",
    "吞"
  ],
  [
    "托",
    "托"
  ],
  [
    "拖",
    "拖"
  ],
  [
    "脫",
    "脫"
  ],
  [
    "瓦",
    "瓦"
  ],
  [
    "頑",
    "頑"
  ],
  [
    "萬",
    "萬"
  ],
  [
    "腕",
    "腕"
  ],
  [
    "尾",
    "尾"
  ],
  [
    "偽",
    "偽"
  ],
  [
    "未",
    "未"
  ],
  [
    "蚊",
    "蚊"
  ],
  [
    "嗡",
    "嗡"
  ],
  [
    "烏",
    "烏"
  ],
  [
    "無",
    "無"
  ],
  [
    "蜈",
    "蜈"
  ],
  [
    "武",
    "武"
  ],
  [
    "舞",
    "舞"
  ],
  [
    "西",
    "西"
  ],
  [
    "蜥",
    "蜥"
  ],
  [
    "席",
    "席"
  ],
  [
    "下",
    "下"
  ],
  [
    "仙",
    "仙"
  ],
  [
    "向",
    "向"
  ],
  [
    "象",
    "象"
  ],
  [
    "橡",
    "橡"
  ],
  [
    "小",
    "小"
  ],
  [
    "謝",
    "謝"
  ],
  [
    "心",
    "心"
  ],
  [
    "新",
    "新"
  ],
  [
    "信",
    "信"
  ],
  [
    "幸",
    "幸"
  ],
  [
    "雄",
    "雄"
  ],
  [
    "熊",
    "熊"
  ],
  [
    "修",
    "修"
  ],
  [
    "朽",
    "朽"
  ],
  [
    "虛",
    "虛"
  ],
  [
    "雪",
    "雪"
  ],
  [
    "鴨",
    "鴨"
  ],
  [
    "牙",
    "牙"
  ],
  [
    "亞",
    "亞"
  ],
  [
    "岩",
    "岩"
  ],
  [
    "炎",
    "炎"
  ],
  [
    "鹽",
    "鹽"
  ],
  [
    "焰",
    "焰"
  ],
  [
    "妖",
    "妖"
  ],
  [
    "搖",
    "搖"
  ],
  [
    "咬",
    "咬"
  ],
  [
    "鑰",
    "鑰"
  ],
  [
    "椰",
    "椰"
  ],
  [
    "野",
    "野"
  ],
  [
    "夜",
    "夜"
  ],
  [
    "葉",
    "葉"
  ],
  [
    "一",
    "一"
  ],
  [
    "伊",
    "伊"
  ],
  [
    "以",
    "以"
  ],
  [
    "音",
    "音"
  ],
  [
    "銀",
    "銀"
  ],
  [
    "引",
    "引"
  ],
  [
    "櫻",
    "櫻"
  ],
  [
    "螢",
    "螢"
  ],
  [
    "泳",
    "泳"
  ],
  [
    "勇",
    "勇"
  ],
  [
    "湧",
    "湧"
  ],
  [
    "幽",
    "幽"
  ],
  [
    "優",
    "優"
  ],
  [
    "由",
    "由"
  ],
  [
    "幼",
    "幼"
  ],
  [
    "雨",
    "雨"
  ],
  [
    "原",
    "原"
  ],
  [
    "圓",
    "圓"
  ],
  [
    "遠",
    "遠"
  ],
  [
    "怨",
    "怨"
  ],
  [
    "月",
    "月"
  ],
  [
    "詐",
    "詐"
  ],
  [
    "戰",
    "戰"
  ],
  [
    "章",
    "章"
  ],
  [
    "長",
    "長"
  ],
  [
    "杖",
    "杖"
  ],
  [
    "沼",
    "沼"
  ],
  [
    "哲",
    "哲"
  ],
  [
    "珍",
    "珍"
  ],
  [
    "榛",
    "榛"
  ],
  [
    "振",
    "振"
  ],
  [
    "正",
    "正"
  ],
  [
    "直",
    "直"
  ],
  [
    "紙",
    "紙"
  ],
  [
    "炙",
    "炙"
  ],
  [
    "智",
    "智"
  ],
  [
    "稚",
    "稚"
  ],
  [
    "種",
    "種"
  ],
  [
    "重",
    "重"
  ],
  [
    "逐",
    "逐"
  ],
  [
    "燭",
    "燭"
  ],
  [
    "滋",
    "滋"
  ],
  [
    "自",
    "自"
  ],
  [
    "鬃",
    "鬃"
  ],
  [
    "走",
    "走"
  ],
  [
    "詛",
    "詛"
  ],
  [
    "鑽",
    "鑽"
  ],
  [
    "坐",
    "坐"
  ],
  [
    null,
    null
  ]
]
